
export type ByteSizeUnit = 'B' | 'KB' | 'MB' | 'GB' | 'TB' | 'PB' | 'EB' | 'ZB' | 'YB';

export class ByteSizeUtil {
    static toReadableText(byteSize?: number) {
        const parts = this.toReadableParts(byteSize)
        return parts ? `${parts.value.toFixed(1)} ${parts.unit}` : undefined
    }

    static toReadableParts(byteSize?: number) {
        if (byteSize === undefined)
            return undefined
        
        const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        let i = 0
        while (byteSize >= 1024 && i < units.length - 1) {
            byteSize /= 1024
            i++
        }
        return { value: byteSize, unit: units[i] }
    }
}
